import { queryOptions } from "@tanstack/react-query";
import { fetchXrplAssetCatalog } from "./asset-catalog";
import { getXrpEtfTracker } from "./markets.functions";
import {
  fetchLedgerPulse,
  fetchXrpChart,
  fetchXrpMarket,
  fetchXrplEcosystem,
  fetchXrplRwa,
  type XrpChartRange,
} from "./markets";

export const xrpMarketQuery = queryOptions({
  queryKey: ["markets", "xrp"],
  queryFn: fetchXrpMarket,
  staleTime: 60_000,
  refetchInterval: 60_000,
});

export const xrpChartQuery = (range: XrpChartRange) =>
  queryOptions({
    queryKey: ["markets", "xrp-chart", range],
    queryFn: () => fetchXrpChart(range),
    staleTime: 60_000,
    retry: 1,
    refetchInterval: range === "7" ? 60_000 : 300_000,
  });



export const xrplEcosystemQuery = queryOptions({
  queryKey: ["markets", "xrpl-ecosystem"],
  queryFn: fetchXrplEcosystem,
  staleTime: 300_000,
});

export const xrplRwaQuery = queryOptions({
  queryKey: ["markets", "xrpl-rwa"],
  queryFn: fetchXrplRwa,
  staleTime: 300_000,
});

export const ledgerPulseQuery = queryOptions({
  queryKey: ["markets", "ledger"],
  queryFn: fetchLedgerPulse,
  staleTime: 30_000,
});

export const xrpEtfQuery = queryOptions({
  queryKey: ["markets", "xrp-etf-tracker"],
  queryFn: async () => {
    try {
      return await getXrpEtfTracker();
    } catch {
      return null;
    }
  },
  staleTime: 300_000,
  retry: 1,
});

export const xrplAssetCatalogQuery = queryOptions({
  queryKey: ["xrpl", "asset-catalog"],
  queryFn: async () => {
    try {
      return await fetchXrplAssetCatalog();
    } catch {
      return [];
    }
  },
  staleTime: 15 * 60_000,
  retry: 1,
});
